module.exports = __webpack_public_path__ + "img/SK.edf67cd0.svg";